export enum PlayerCardTabs {
  Overview = 'Overview',
  Transactions = 'Transactions',
  Comments = 'Comments',
  Bets = 'Bets',
  History = 'History',
  Bonuses = 'Bonuses',
  Limits = 'Limits',
  LinkedPlayers = 'Linked Players',
}
